import React from 'react';
import CandleChartCard from './components/CandleChartCard';
import { Box, Grid, Tab, Tabs, Typography} from "@material-ui/core";
import { InterpolateValue } from "../../../../store/chartReducer";
import PropTypes from 'prop-types';
import DiveBarExploreCard from "layout/LiteTakyonLayout/DiveBarClub/DiveBarExploreCard";
import DiveBarLendingCard from "layout/LiteTakyonLayout/DiveBarClub/DiveBarLendingCard";
import DiveBarStakingCard from "layout/LiteTakyonLayout/DiveBarClub/DiveBarStakingCard";
import DiveBarNFTCard from "layout/LiteTakyonLayout/DiveBarClub/DiveBarNFTCard";
import MultiChart from "../MultiChart";
import TableCard from "./components/TableCard";
import { useDispatch, useSelector } from "react-redux";
import { map_coins } from 'store/constant';

const CoinDetails = ({coin}) => {
  const key_style = map_coins.get(coin);

  const ltp  = useSelector((state) => {
    return state.coins.kraken_asset_pairs.get(coin) || {ltp: 0.00};
    });

    return (
        <div style={{position:'relative'}}>

          <div
          style={{
            height: '35px',
            width: '90px',
            boxAlign: 'center',
            alignItems: 'center',
            padding: '0px',
            backgroundColor: '#000',
            borderRadius: '0px',
            border: '0px solid rgb(68 68 68)',
            whiteSpace: 'nowrap',
          }}
          >
            <div>
            <font sx={{ "font-size": "0.8rem" }} class={key_style} >{coin}</font>

            </div>
            <div>
            <font sx={{ 'color': 'white', "font-size": "0.8rem" }} >{ltp.ltp}</font>
            </div>
          </div>
        </div>
    )
}

// tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Grid item xs={12} md={12}>
          <Typography variant="h4" sx={{color: 'white'}}>{children}</Typography>
        </Grid>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const CandleChartLayout  = () => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        console.log('------------------ TAB VALUE --------- ' + newValue + ', ' + value);
        console.log( favcoins[value].label);
    }; 

    let favcoins = useSelector((state) => state.favorites.favorites);

    console.log(favcoins);
    const flen = favcoins.length;

    const mc = Array.from({length: 12}, () => flen);
    const pnlDataMap = useSelector((state) => state.chart.pnlDataMap);
    console.log(pnlDataMap);

    for( let i = 1; i <= 12; ++i    )
    {
        if ( i <= mc[i-1])
        {
            mc[i-1] -= i;
        } else {
            mc[i-1] = (mc[i-1] - i + 12)%flen;
        }
        console.log(pnlDataMap.get(favcoins[mc[i-1]].label));
        favcoins[mc[i-1]].explore_list = pnlDataMap.get(favcoins[mc[i-1]].label);
        // TMD console.log(favcoins[mc[i-1]].label);
        // TMD console.log(favcoins[mc[i-1]].explore_list);
    }

    console.log('EXPLORE_____DATA____LIST___FROM___MAP ' + favcoins[mc[value]].label);
    console.log(favcoins[mc[value]].explore_list);


    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Tabs
            value={value}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            aria-label="simple tabs example"
            variant="scrollable"
          >

            <Tab value={0} onChange={handleChange} label={ <CoinDetails coin={favcoins[0].label} />} />
            <Tab value={1} onChange={handleChange} label={ <CoinDetails coin={favcoins[1].label} />} />
            <Tab value={2} onChange={handleChange} label={ <CoinDetails coin={favcoins[2].label} />} />
            <Tab value={3} onChange={handleChange} label={ <CoinDetails coin={favcoins[3].label} />} />
            <Tab value={4} onChange={handleChange} label={ <CoinDetails coin={favcoins[4].label} />} />
            <Tab value={5} onChange={handleChange} label={ <CoinDetails coin={favcoins[5].label} />} />
            <Tab value={6} onChange={handleChange} label={ <CoinDetails coin={favcoins[6].label} />} />
            <Tab value={7} onChange={handleChange} label={ <CoinDetails coin={favcoins[7].label} />} />
            <Tab value={8} onChange={handleChange} label={ <CoinDetails coin={favcoins[8].label} />} />
            <Tab value={9} onChange={handleChange} label={ <CoinDetails coin={favcoins[9].label} />} />
            <Tab value={10} onChange={handleChange} label={ <CoinDetails coin={favcoins[10].label} />} />
            <Tab value={11} onChange={handleChange} label={ <CoinDetails coin={favcoins[11].label} />} />

          </Tabs>

          <TabPanel value={value} index={0}>
             <MultiChart index={0} coin={favcoins[0].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[0].label} rows={favcoins[0].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={1}>
             <MultiChart index={1} coin={favcoins[1].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[1].label} rows={favcoins[1].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={2}>
             <MultiChart index={2} coin={favcoins[2].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[2].label} rows={favcoins[2].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={3}>
             <MultiChart index={3} coin={favcoins[3].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[3].label} rows={favcoins[3].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={4}>
             <MultiChart index={4} coin={favcoins[4].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[4].label} rows={favcoins[4].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={5}>
             <MultiChart index={5} coin={favcoins[5].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[5].label} rows={favcoins[5].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={6}>
             <MultiChart index={6} coin={favcoins[6].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[6].label} rows={favcoins[6].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={7}>
             <MultiChart index={7} coin={favcoins[7].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[7].label} rows={favcoins[7].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={8}>
             <MultiChart index={8} coin={favcoins[8].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[8].label} rows={favcoins[8].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={9}>
             <MultiChart index={9} coin={favcoins[9].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[9].label} rows={favcoins[9].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={10}>
             <MultiChart index={10} coin={favcoins[10].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[10].label} rows={favcoins[10].explore_list} />
          </TabPanel>

          <TabPanel value={value} index={11}>
             <MultiChart index={11} coin={favcoins[11].label} />
             <TableCard title="AI-Robo-Advisor" coin_name={favcoins[11].label} rows={favcoins[11].explore_list} />
          </TabPanel>

        </Grid>
      </Grid>
    );
}

export default React.memo(CandleChartLayout);
